//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const RecheduleAppointment = createAsyncThunk(
  "RecheduleAppointment",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingRecheduleAppointment(""));
      const response = await UsePortalApi(
        `Patient/RecheduleAppointment`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
         dispatch(gettingRecheduleAppointmentSuccess(response))

      } else {
        dispatch(
          gettingRecheduleAppointmentFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingRecheduleAppointmentFailed(error));
    }
  }
);
const RecheduleAppointmentSlice = createSlice({
  name: "RecheduleAppointment",
  initialState: {
    RecheduleAppointmentData: null,
    isRecheduleAppointmentData: false,
    isRecheduleAppointmentError: false,
  },
  reducers: {
    gettingRecheduleAppointment: (state, action) => {
      state.RecheduleAppointmentData = null;
      state.isRecheduleAppointmentData = true;
      state.isRecheduleAppointmentError = false;
    },
    gettingRecheduleAppointmentSuccess: (state, action) => {
      state.RecheduleAppointmentData = action.payload;
      state.isRecheduleAppointmentData = false;
      state.isRecheduleAppointmentError = false;
    },
    gettingRecheduleAppointmentFailed: (state, action) => {
      state.RecheduleAppointmentData = null;
      state.isRecheduleAppointmentData = false;
      state.isRecheduleAppointmentError = true;
    },
    gettingRecheduleAppointmentClear: (state, action) => {
      state.RecheduleAppointmentData = null;
      state.isRecheduleAppointmentData = false;
      state.isRecheduleAppointmentError = false;
    },
  },
});
export const {
  gettingRecheduleAppointment,
  gettingRecheduleAppointmentSuccess,
  gettingRecheduleAppointmentFailed,
  gettingRecheduleAppointmentClear,
} = RecheduleAppointmentSlice.actions;
export default RecheduleAppointmentSlice.reducer;
